// Generic polyfills
import "babel-polyfill";

// Array.from
import "core-js/fn/array/from";

// querySelector(...).forEach
if (
  typeof window !== "undefined" &&
  window.NodeList &&
  !NodeList.prototype.forEach
) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// IE11 CustomEvent support
const replaceGlobalEvent = typeof window !== "undefined" && window.Event;
import "custom-event-polyfill";
if (replaceGlobalEvent) {
  window.Event = window.CustomEvent;
}

// IE11 Intersection Observer
import "intersection-observer";
